import { FC, useEffect, useState } from 'react'
import { Button, Grid } from '@aurecon-creative-technologies/styleguide'
import { useRecoilState } from 'recoil'
import Cookies from 'universal-cookie'
import { useAuth0 } from '@auth0/auth0-react'
import { add } from 'date-fns'
import { useLocation } from 'react-router-dom'

import { TermsModal } from '../stores/AppStore'
import config from '../config/config'
import { Modal } from './Modal'

import Style from '../styles/TermsCookiesModal.module.sass'

const cookies = new Cookies()

const TermsCookiesModal: FC = () => {
  const { logout } = useAuth0()
  const { pathname } = useLocation()
  const [acceptedCookies, setAcceptedCookies] = useState(false)
  const [acceptedTerms, setAcceptedTerms] = useState(false)
  const [termsModal, setTermsModal] = useRecoilState(TermsModal)

  useEffect(() => {
    const c = cookies.get('wwoap.cookies')
    const t = cookies.get('wwoap.terms')

    if (c && c.accepted) setAcceptedCookies(true)
    if (t && t.accepted) setAcceptedTerms(true)
  }, [])

  useEffect(() => {
    setTermsModal(!acceptedTerms || !acceptedCookies)
  }, [acceptedCookies, acceptedTerms, setTermsModal])

  const handleAcceptTerms = () => {
    cookies.set('wwoap.terms', { accepted: true }, { path: '/', expires: add(new Date(), { years: 1 }) })
    setAcceptedTerms(true)
  }

  const handleAcceptCookies = () => {
    cookies.set('wwoap.cookies', { accepted: true }, { path: '/', expires: add(new Date(), { years: 1 }) })
    setAcceptedCookies(true)
  }

  const handleDeclineTerms = () => {
    cookies.set('wwoap.terms', { accepted: false }, { path: '/', expires: add(new Date(), { years: 1 }) })

    setAcceptedTerms(false)
    logout({ returnTo: config.AUTH0_LOGOUT_RETURN })
  }

  const handleCloseModal = () => {
    // required callback for modal
  }

  const noOverlayPages =
    pathname.includes('termsandconditions') || pathname.includes('cookie') || pathname.includes('privacy')

  if (noOverlayPages) return null

  return (
    <Modal
      isShowing={termsModal}
      onClose={handleCloseModal}
      isCloseButton={false}
      size='medium'
      cssClass={Style.cookieModal}
      isOverlay={true}
    >
      {!acceptedTerms && (
        <Grid row gap={12}>
          <Grid item cell xs={8} cssClass={Style.center}>
            <p>
              Please consent to the{' '}
              <a href='/#/termsandconditions' target='_blank' rel='noreferrer'>
                Terms & Conditions
              </a>{' '}
              and{' '}
              <a href='/#/privacy' target='_blank' rel='noreferrer'>
                Privacy Policy
              </a>
              .
            </p>
          </Grid>
          <Grid item cell cssClass={Style.center}>
            <Button label='Decline' type='secondary' onClick={handleDeclineTerms} />
          </Grid>
          <Grid item cell cssClass={Style.center}>
            <Button label='Accept' onClick={handleAcceptTerms} />
          </Grid>
        </Grid>
      )}
      {!acceptedCookies && !acceptedTerms && <div className={Style.modalDivider} />}
      {!acceptedCookies && (
        <Grid row gap={12}>
          <Grid item cell xs={10} cssClass={Style.center}>
            <p>
              We use cookies to ensure that we give you the best experience on our application.{' '}
              <a href='/#/cookies' target='_blank' rel='noreferrer'>
                Find out more
              </a>
            </p>
          </Grid>
          <Grid item cell cssClass={Style.center}>
            <Button label='Accept' onClick={handleAcceptCookies} />
          </Grid>
        </Grid>
      )}
    </Modal>
  )
}

export default TermsCookiesModal
